import {GameStatusType} from './GameStatusStore.constants';
import {GameStatusState} from './GameStatusStore.types';

import {Store} from '../Store';

export class GameStatusStore extends Store<GameStatusState> {
  constructor() {
    super({
      status: GameStatusType.Active,
    });
  }

  public setStatus(status: GameStatusType): void {
    this.setValue('status', status);
  }

  public getStatus = (): GameStatusType => {
    return this.getState().status;
  };

  public isStatusActive(): boolean {
    return this.getState().status === GameStatusType.Active;
  }

  public isStatusLeaguesRecalculation(): boolean {
    return this.getState().status === GameStatusType.LeaguesRecalculation;
  }

  public isStatusGameFinishedBeforeResults(): boolean {
    return this.getState().status === GameStatusType.GameFinishedBeforeResults;
  }

  public isStatusGameFinishedAfterResults(): boolean {
    return this.getState().status === GameStatusType.GameFinishedAfterResults;
  }

  public isStatusGameFinished(): boolean {
    return this.isStatusGameFinishedBeforeResults() || this.isStatusGameFinishedAfterResults();
  }

  public isStatusGameMocks(): boolean {
    return this.getState().status === GameStatusType.Mocks;
  }
}
